import { SmartStorage } from "smart-core-util";
import { httpService } from "../service/httpService";
var enviroment = process.env.VUE_APP_ENV; // 线上

export default class RouterQueue {
  static install() {
    return new Promise(function (resolve) {
      let url = `https://spkg.smartmice.cn/configuration/iapp-config/roche/${enviroment}/routerQueue.json`;
      let params = {
        params: {
          rnd: new Date().getTime(),
        },
      };

      httpService
        .Get(url, params)
        .then((response) => {
          RouterQueue.setRouterQueue(response.routerList || []);

          resolve(response);
        })
        .catch((error) => {
          resolve(error);
        });
    });
  }
  // 设置路由队列
  static setRouterQueue(routerList = {}) {
    SmartStorage.remove("currentRouter");
    SmartStorage.set("router_queue", routerList);
  }
}
